import axios from 'axios';
import { message } from 'antd';
import history from './history';

// 允许调用方在单个请求上声明自行处理报错（如上传组件需自行展示接口具体报错）
declare module 'axios' {
  export interface AxiosRequestConfig {
    skipErrorHandler?: boolean;
  }
}

const request = axios.create({
  baseURL: process.env.REACT_APP_SERVER_BASE,
  withCredentials: true,
  timeout: 10000,
});

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // 无 response（断网等）时原样抛出，由调用方自行处理
    if (!error.response) {
      return Promise.reject(error);
    }

    // 调用方声明自行处理报错时，跳过全局提示，将接口响应体抛给调用方
    if (error.config?.skipErrorHandler) {
      return Promise.reject(error.response.data);
    }

    const { data } = error.response;
    console.log('%c json api errors message: ', 'color:#ff4d4f;font-size:18px;');
    console.table(data);
    const { errors } = data;
    if (errors?.status === 401) {
      // eslint-disable-next-line camelcase
      window.location.href = errors?.redirect_url;
    }
    if (errors?.status === 403 && errors.code === 10005) {
      history.push('/?subscribe=0');
    }
    if (errors?.status === 404) {
      history.push(`/exception/forbidden/${errors?.status}/${errors?.detail}`);
    }
    if (errors?.status === 400) {
      message.error('请求错误');
    }
    if (errors?.status === 500) {
      message.error('当前网络不佳，请稍后再试~');
    }
    return Promise.reject(data);
  },
);

export default request;
